import { AppMarket } from "../pages/Works"

const getImageUrl = (app: AppMarket, setTitle: any, setItems: any) => {
    switch (app) {
        case AppMarket.mrEnglish:
            setTitle('Mr English');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/mrEnglish/banner1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/mrEnglish/banner2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/mrEnglish/banner3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/mrEnglish/banner4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/mrEnglish/banner5.png'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/mrEnglish/banner6.png'
                },
                {
                    title: 'Banner 7',
                    url: 'https://arashaltafi.ir/images/mrEnglish/banner7.png'
                },
                {
                    title: 'Banner 8',
                    url: 'https://arashaltafi.ir/images/mrEnglish/banner8.png'
                },
                {
                    title: 'Banner 9',
                    url: 'https://arashaltafi.ir/images/mrEnglish/1.png'
                },
                {
                    title: 'Banner 10',
                    url: 'https://arashaltafi.ir/images/mrEnglish/2.png'
                },
                {
                    title: 'Banner 11',
                    url: 'https://arashaltafi.ir/images/mrEnglish/3.png'
                },
                {
                    title: 'Banner 12',
                    url: 'https://arashaltafi.ir/images/mrEnglish/4.png'
                },
                {
                    title: 'Banner 13',
                    url: 'https://arashaltafi.ir/images/mrEnglish/5.png'
                },
                {
                    title: 'Banner 14',
                    url: 'https://arashaltafi.ir/images/mrEnglish/6.png'
                },
                {
                    title: 'Banner 15',
                    url: 'https://arashaltafi.ir/images/mrEnglish/7.png'
                },
                {
                    title: 'Banner 16',
                    url: 'https://arashaltafi.ir/images/mrEnglish/8.png'
                },
                {
                    title: 'Banner 17',
                    url: 'https://arashaltafi.ir/images/mrEnglish/9.png'
                },
                {
                    title: 'Banner 18',
                    url: 'https://arashaltafi.ir/images/mrEnglish/10.png'
                },
                {
                    title: 'Banner 19',
                    url: 'https://arashaltafi.ir/images/mrEnglish/11.png'
                },
                {
                    title: 'Banner 20',
                    url: 'https://arashaltafi.ir/images/mrEnglish/12.png'
                },
                {
                    title: 'Banner 21',
                    url: 'https://arashaltafi.ir/images/mrEnglish/13.png'
                },
                {
                    title: 'Banner 22',
                    url: 'https://arashaltafi.ir/images/mrEnglish/14.png'
                },
                {
                    title: 'Banner 23',
                    url: 'https://arashaltafi.ir/images/mrEnglish/15.png'
                },
                {
                    title: 'Banner 24',
                    url: 'https://arashaltafi.ir/images/mrEnglish/16.png'
                },
                {
                    title: 'Banner 25',
                    url: 'https://arashaltafi.ir/images/mrEnglish/17.png'
                },
                {
                    title: 'Banner 26',
                    url: 'https://arashaltafi.ir/images/mrEnglish/18.png'
                },
                {
                    title: 'Banner 27',
                    url: 'https://arashaltafi.ir/images/mrEnglish/19.png'
                },
                {
                    title: 'Banner 28',
                    url: 'https://arashaltafi.ir/images/mrEnglish/20.png'
                },
                {
                    title: 'Banner 29',
                    url: 'https://arashaltafi.ir/images/mrEnglish/21.png'
                },
                {
                    title: 'Banner 30',
                    url: 'https://arashaltafi.ir/images/mrEnglish/22.png'
                },
                {
                    title: 'Banner 31',
                    url: 'https://arashaltafi.ir/images/mrEnglish/23.png'
                },
                {
                    title: 'Banner 32',
                    url: 'https://arashaltafi.ir/images/mrEnglish/24.png'
                },
            ]);
            break;
        case AppMarket.tvOnline:
            setTitle('Tv Online');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/tvOnline/banner1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/tvOnline/banner2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/tvOnline/banner3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/tvOnline/banner4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/tvOnline/1.jpg'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/tvOnline/2.jpg'
                },
                {
                    title: 'Banner 7',
                    url: 'https://arashaltafi.ir/images/tvOnline/3.jpg'
                },
                {
                    title: 'Banner 8',
                    url: 'https://arashaltafi.ir/images/tvOnline/4.jpg'
                },
                {
                    title: 'Banner 9',
                    url: 'https://arashaltafi.ir/images/tvOnline/5.jpg'
                },
                {
                    title: 'Banner 10',
                    url: 'https://arashaltafi.ir/images/tvOnline/6.jpg'
                },
                {
                    title: 'Banner 11',
                    url: 'https://arashaltafi.ir/images/tvOnline/7.jpg'
                },
                {
                    title: 'Banner 12',
                    url: 'https://arashaltafi.ir/images/tvOnline/8.jpg'
                },
                {
                    title: 'Banner 13',
                    url: 'https://arashaltafi.ir/images/tvOnline/9.jpg'
                },
                {
                    title: 'Banner 14',
                    url: 'https://arashaltafi.ir/images/tvOnline/10.jpg'
                },
                {
                    title: 'Banner 15',
                    url: 'https://arashaltafi.ir/images/tvOnline/11.jpg'
                },
                {
                    title: 'Banner 16',
                    url: 'https://arashaltafi.ir/images/tvOnline/12.jpg'
                },
                {
                    title: 'Banner 17',
                    url: 'https://arashaltafi.ir/images/tvOnline/13.jpg'
                },
                {
                    title: 'Banner 18',
                    url: 'https://arashaltafi.ir/images/tvOnline/14.jpg'
                },
                {
                    title: 'Banner 19',
                    url: 'https://arashaltafi.ir/images/tvOnline/15.jpg'
                },
                {
                    title: 'Banner 20',
                    url: 'https://arashaltafi.ir/images/tvOnline/16.jpg'
                },
                {
                    title: 'Banner 21',
                    url: 'https://arashaltafi.ir/images/tvOnline/17.jpg'
                },
                {
                    title: 'Banner 22',
                    url: 'https://arashaltafi.ir/images/tvOnline/18.jpg'
                },
                {
                    title: 'Banner 23',
                    url: 'https://arashaltafi.ir/images/tvOnline/19.jpg'
                },
                {
                    title: 'Banner 24',
                    url: 'https://arashaltafi.ir/images/tvOnline/20.jpg'
                },

            ]);
            break;
        case AppMarket.speedMeter:
            setTitle('Speed Meter');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/speedMeter/1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/speedMeter/2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/speedMeter/3.png'
                },
            ]);
            break;
        case AppMarket.workout:
            setTitle('Workout');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/workout/banner1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/workout/banner2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/workout/banner3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/workout/1.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/workout/2.png'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/workout/3.png'
                },
                {
                    title: 'Banner 7',
                    url: 'https://arashaltafi.ir/images/workout/4.png'
                },
                {
                    title: 'Banner 8',
                    url: 'https://arashaltafi.ir/images/workout/5.png'
                },
                {
                    title: 'Banner 9',
                    url: 'https://arashaltafi.ir/images/workout/6.png'
                },
                {
                    title: 'Banner 10',
                    url: 'https://arashaltafi.ir/images/workout/7.png'
                },
                {
                    title: 'Banner 11',
                    url: 'https://arashaltafi.ir/images/workout/8.png'
                },
                {
                    title: 'Banner 12',
                    url: 'https://arashaltafi.ir/images/workout/9.png'
                },
                {
                    title: 'Banner 13',
                    url: 'https://arashaltafi.ir/images/workout/10.png'
                },
            ]);
            break;
        case AppMarket.meditation:
            setTitle('Meditation');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/meditation/banner1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/meditation/banner2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/meditation/1.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/meditation/2.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/meditation/3.png'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/meditation/4.png'
                },
                {
                    title: 'Banner 7',
                    url: 'https://arashaltafi.ir/images/meditation/5.png'
                },
                {
                    title: 'Banner 8',
                    url: 'https://arashaltafi.ir/images/meditation/6.png'
                },
                {
                    title: 'Banner 9',
                    url: 'https://arashaltafi.ir/images/meditation/7.png'
                },
            ]);
            break;
        case AppMarket.video:
            setTitle('Video');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/be_vaght_film/be_vaght_film_1.jpg'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/be_vaght_film/be_vaght_film_2.jpg'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/be_vaght_film/be_vaght_film_3.jpg'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/be_vaght_film/be_vaght_film_4.jpg'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/be_vaght_film/be_vaght_film_5.jpg'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/be_vaght_film/be_vaght_film_6.jpg'
                },
                {
                    title: 'Banner 7',
                    url: 'https://arashaltafi.ir/images/be_vaght_film/be_vaght_film_7.jpg'
                },
            ]);
            break;
        case AppMarket.neshan:
            setTitle('Neshan');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/neshan/1.jpg'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/neshan/2.jpg'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/neshan/3.jpg'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/neshan/4.jpg'
                },
            ]);
            break;
        case AppMarket.chatGpt:
            setTitle('ChatGpt');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/chatGpt/1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/chatGpt/2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/chatGpt/3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/chatGpt/4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/chatGpt/5.png'
                },
            ]);
            break;
        case AppMarket.documentBage:
            setTitle('Document Bage');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/documentBage/1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/documentBage/2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/documentBage/3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/documentBage/4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/documentBage/5.png'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/documentBage/6.png'
                },
                {
                    title: 'Banner 7',
                    url: 'https://arashaltafi.ir/images/documentBage/7.png'
                },
                {
                    title: 'Banner 8',
                    url: 'https://arashaltafi.ir/images/documentBage/8.png'
                },
                {
                    title: 'Banner 9',
                    url: 'https://arashaltafi.ir/images/documentBage/9.png'
                },
                {
                    title: 'Banner 10',
                    url: 'https://arashaltafi.ir/images/documentBage/10.png'
                },
                {
                    title: 'Banner 11',
                    url: 'https://arashaltafi.ir/images/documentBage/11.png'
                },
                {
                    title: 'Banner 12',
                    url: 'https://arashaltafi.ir/images/documentBage/12.png'
                },
                {
                    title: 'Banner 13',
                    url: 'https://arashaltafi.ir/images/documentBage/13.png'
                },
                {
                    title: 'Banner 14',
                    url: 'https://arashaltafi.ir/images/documentBage/14.png'
                },
            ]);
            break;
        case AppMarket.driving:
            setTitle('Driving');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/driving/1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/driving/2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/driving/3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/driving/4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/driving/5.png'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/driving/6.png'
                },
                {
                    title: 'Banner 7',
                    url: 'https://arashaltafi.ir/images/driving/7.png'
                },
                {
                    title: 'Banner 8',
                    url: 'https://arashaltafi.ir/images/driving/8.png'
                },
                {
                    title: 'Banner 9',
                    url: 'https://arashaltafi.ir/images/driving/9.png'
                },
            ]);
            break;
        case AppMarket.bmi:
            setTitle('Bmi');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/bmi/1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/bmi/2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/bmi/3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/bmi/4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/bmi/5.png'
                },
            ]);
            break;
        case AppMarket.joke:
            setTitle('Joke');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/joke/joke_1.jpg'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/joke/joke_2.jpg'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/joke/joke_3.jpg'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/joke/joke_4.jpg'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/joke/joke_5.jpg'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/joke/joke_6.jpg'
                },
            ]);
            break;
        case AppMarket.salavatShomar:
            setTitle('SalavatShomar');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/salavat_shomar/salavat_1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/salavat_shomar/salavat_2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/salavat_shomar/salavat_3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/salavat_shomar/salavat_4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/salavat_shomar/salavat_5.png'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/salavat_shomar/salavat_6.png'
                },
            ]);
            break;
        case AppMarket.shop1:
            setTitle('Shop1');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/shop1/shop_1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/shop1/shop_2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/shop1/shop_3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/shop1/shop_4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/shop1/shop_5.png'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/shop1/shop_6.png'
                },
            ]);
            break;
        case AppMarket.shop2:
            setTitle('Shop2');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/shop2/shop_1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/shop2/shop_2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/shop2/shop_3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/shop2/shop_4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/shop2/shop_5.png'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/shop2/shop_6.png'
                },
                {
                    title: 'Banner 7',
                    url: 'https://arashaltafi.ir/images/shop2/shop_7.png'
                },
                {
                    title: 'Banner 8',
                    url: 'https://arashaltafi.ir/images/shop2/shop_8.png'
                },
                {
                    title: 'Banner 9',
                    url: 'https://arashaltafi.ir/images/shop2/shop_9.png'
                },
                {
                    title: 'Banner 10',
                    url: 'https://arashaltafi.ir/images/shop2/shop_10.png'
                },
                {
                    title: 'Banner 11',
                    url: 'https://arashaltafi.ir/images/shop2/shop_11.png'
                },
                {
                    title: 'Banner 12',
                    url: 'https://arashaltafi.ir/images/shop2/shop_12.png'
                },
                {
                    title: 'Banner 13',
                    url: 'https://arashaltafi.ir/images/shop2/shop_13.png'
                },
                {
                    title: 'Banner 14',
                    url: 'https://arashaltafi.ir/images/shop2/shop_14.png'
                },
            ]);
            break;
        case AppMarket.WhatsAppDownloader:
            setTitle('WhatsApp Downloader');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/WhatsAppDownloader/1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/WhatsAppDownloader/2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/WhatsAppDownloader/3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/WhatsAppDownloader/4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/WhatsAppDownloader/5.png'
                },
                {
                    title: 'Banner 6',
                    url: 'https://arashaltafi.ir/images/WhatsAppDownloader/6.png'
                },
                {
                    title: 'Banner 7',
                    url: 'https://arashaltafi.ir/images/WhatsAppDownloader/7.png'
                },
                {
                    title: 'Banner 8',
                    url: 'https://arashaltafi.ir/images/WhatsAppDownloader/8.png'
                },
                {
                    title: 'Banner 9',
                    url: 'https://arashaltafi.ir/images/WhatsAppDownloader/9.png'
                },
            ]);
            break;
        case AppMarket.calculator:
            setTitle('Calculator');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/calculator/2.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/calculator/3.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/calculator/4.png'
                },
            ]);
            break;
        case AppMarket.videoToGif:
            setTitle('Video To Gif');
            setItems([
                {
                    title: 'Banner 1',
                    url: 'https://arashaltafi.ir/images/videoToGif/1.png'
                },
                {
                    title: 'Banner 2',
                    url: 'https://arashaltafi.ir/images/videoToGif/2.png'
                },
                {
                    title: 'Banner 3',
                    url: 'https://arashaltafi.ir/images/videoToGif/3.png'
                },
                {
                    title: 'Banner 4',
                    url: 'https://arashaltafi.ir/images/videoToGif/4.png'
                },
                {
                    title: 'Banner 5',
                    url: 'https://arashaltafi.ir/images/videoToGif/5.png'
                },
            ]);
            break;
        default:
            break;
    }
}

export default getImageUrl